import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Home } from 'pages/Home';
import { About } from 'pages/About';
import { Contact } from 'pages/Contact';
import { Test } from "pages/Test";
import { WhatWeDo } from "pages/WhatWeDo";
import { ThemeProvider } from '@mui/material/styles';
import { createTheme } from '@mui/material';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

const App = () => (
  <ThemeProvider theme={darkTheme}>
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
          <Route path="test" element={<Test />} />
          <Route path="whatwedo" element={<WhatWeDo />} />
        </Routes>
      </BrowserRouter>
    </div>
  </ThemeProvider>
);

export default App;